import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.softPink,
  fontColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default promoBanner;